import { Navigate } from "react-router-dom";
import { StorageEnums } from "../enums/storageEnums";

const AuthGuard = ({ children, ...rest }: any) => {
  const user = localStorage.getItem(StorageEnums.CREDENTIALS);
  return user ? children : <Navigate to="/" />;
};

export default AuthGuard;
